// Test IDs for SSH settings components
export const SSH_SETTING_TEST_IDS = {
  root: 'ssh-keys',
  header: 'ssh-keys-header',
  searchInput: 'ssh-keys-search-input',
  syncButton: 'ssh-keys-sync-btn',
  addButton: 'ssh-keys-add-btn',
  syncBanner: 'ssh-keys-sync-banner',
  emptyStateButton: 'ssh-keys-empty-state-btn',
  warning: 'ssh-keys-warning',
};
